<h5 class="pb-4 pt-4 text-center m-0">Explore LearningMedia Resources by Subject</h5>
<div class="d-flex flex-wrap justify-content-center">
    <ng-container *ngIf="subjects">
        <a
            *ngFor="let subject of subjects"
            class="subject-item d-flex align-items-center justify-content-center col-6 col-sm-4 col-md-3"
            [routerLink]="['/subjects', subject.slug]"
        >
            <app-avatar
                [avatarImage]="subject.posterImage"
                [avatarTitle]="subject.title"
                [titleColor]="ColorCode.SubjectColor[subject.id]"
            >
            </app-avatar>
        </a>
    </ng-container>
</div>
